import {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { StorageService } from "../services/Storage";
import InsightService from "../services/Insight";

const onRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  let token;
  const store = StorageService.getPepperStore();
  if(store) {
    const data = store;
    token = data.accessToken;
  }

  if (token) {
    if (config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers["Content-Type"] = "application/json";
      return config;
    }
  }

  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  InsightService.logEvent("Request", [
    {
      request: {
        requestURL: response.request?.responseURL,
        config: response.config,
      },
    },
    { response: response.data },
  ]);
  return response.data.data;
};

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  if (!error.status) {
    InsightService.logTrace('ResponseError', [{ code: error.code}, { message: error.message}, {status: error.status }, {errorData: JSON.stringify(error)}]);
  }
  InsightService.logException(error);
  return Promise.reject(error);
};

export function setupInterceptorsTo(
  axiosInstance: AxiosInstance
): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
